// DO NOT EDIT BY HAND — populated by: npm run extract-letterform

import type { LetterMasters } from "@/types/letterform"

export const letterM: LetterMasters = {
  commands: [
    "M",
    "V",
    "H",
    "V",
    "H",
    "V",
    "H",
    "V",
    "H",
    "V",
    "H",
    "V",
    "H",
    "V",
    "H",
    "V",
    "H",
    "Z",
  ],
  narrowTall: [
    0, 0, 1024, 12, 384, 16, 1024, 52, 384, 56, 1024, 64, 0, 34, 512, 30, 0, 0,
  ],
  wideShort: [
    0, 0, 64, 196, 24, 200, 64, 824, 24, 828, 64, 1024, 0, 514, 32, 510, 0, 0,
  ],
  narrowArtboard: [64, 1024],
  wideArtboard: [1024, 64],
  minAspect: 0.0625,
  maxAspect: 16,
  minGaps: [
    { indexA: 3, indexB: 5, minPx: 1, targetPx: 4 },
    { indexA: 7, indexB: 9, minPx: 1, targetPx: 4 },
    { indexA: 13, indexB: 15, minPx: 1, targetPx: 4 },
  ],
  linkedPairs: [
    { source: 0, target: 17 },
    { source: 1, target: 12 },
    { source: 1, target: 16 },
    { source: 2, target: 6 },
    { source: 2, target: 10 },
    { source: 4, target: 8 },
  ],
}
